export default __webpack_public_path__ + "../images/safari-pinned-tab.svg";